import ListTypes from "./ListTypes";
import ListItems from "./ListItems";

const List = ({ items = false, type = false, sharing = false } = {}) => `
  id
  ${
    items
      ? `items {
      ${ListItems}
    }`
      : ""
  }
  itemsCount
  name
  ${
    type
      ? `type {
      ${ListTypes}
    }`
      : ""
  }
  typeId
  userId
  updatedAt
  ${
    sharing
      ? `isShared
  isOwner
  sharedWith {
    id
    email
    meta
  }
  sharedBy {
    id
    email
    meta
  }`
      : ""
  }
`;

export default List;
